<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div v-if="supportedTypes() == 0">
    <div class="meeting_type_not_set" v-t="'message.AgendaCard.unavailable'"></div>
  </div>
  <div v-if="supportedTypes() == 1">
    <div v-if="appointment.meeting_types.in_person" v-t="'message.AgendaCard.in_person'"></div>
    <div v-if="appointment.meeting_types.virtual" v-t="'message.AgendaCard.virtual'"></div>
    <div v-if="appointment.meeting_types.phone" v-t="'message.AgendaCard.phone'"></div>
    <div v-if="appointment.meeting_types.callback" v-t="'message.AgendaCard.callback'"></div>
  </div>

  <div v-if="supportedTypes() > 1">
    <div
      class="btn-group btn-group-sm btn-group-radio"
      role="group"
      :aria-label="'Meeting Types' + id"
    >
      <input
        type="radio"
        class="btn-check"
        :name="'radio-' + appointment.pta_id + id"
        :id="appointment.pta_id + '-in_person' + id"
        autocomplete="off"
        v-if="appointment.meeting_types.in_person"
        value="in_person"
        v-model="appointment.meeting_type"
        @change="save('in_person')"
      />
      <label
        class="btn btn-outline-primary"
        :for="appointment.pta_id + '-in_person' + id"
        v-if="appointment.meeting_types.in_person"
        style="white-space: nowrap"
        >{{ $t("message.AgendaCard.in_person") }}</label
      >

      <input
        type="radio"
        class="btn-check"
        :name="'radio-' + appointment.pta_id + id"
        :id="appointment.pta_id + '-virtual' + id"
        autocomplete="off"
        v-if="appointment.meeting_types.virtual"
        value="virtual"
        v-model="appointment.meeting_type"
        @change="save('virtual')"
      />
      <label
        class="btn btn-outline-primary"
        :for="appointment.pta_id + '-virtual' + id"
        v-if="appointment.meeting_types.virtual"
        >{{ $t("message.AgendaCard.virtual") }}</label
      >

      <input
        type="radio"
        class="btn-check"
        :name="'radio-' + appointment.pta_id + id"
        :id="appointment.pta_id + '-phone' + id"
        autocomplete="off"
        v-if="appointment.meeting_types.phone"
        value="phone"
        v-model="appointment.meeting_type"
        @change="save('phone')"
      />
      <label
        class="btn btn-outline-primary"
        :for="appointment.pta_id + '-phone' + id"
        v-if="appointment.meeting_types.phone"
        >{{ $t("message.AgendaCard.phone") }}</label
      >

      <input
        type="radio"
        class="btn-check"
        :name="'radio-' + appointment.pta_id + id"
        :id="appointment.pta_id + '-callback' + id"
        autocomplete="off"
        v-if="appointment.meeting_types.callback"
        value="callback"
        v-model="appointment.meeting_type"
        @change="save('callback')"
      />
      <label
        class="btn btn-outline-primary"
        :for="appointment.pta_id + '-callback' + id"
        v-if="appointment.meeting_types.callback"
        >{{ $t("message.AgendaCard.callback") }}</label
      >
    </div>
  </div>
</template>
<script setup>
import { useAgendaStore } from "@/stores/parent/agenda";
import { useAuthenticationStore } from "@/stores/authentication";

const agendaStore = useAgendaStore();
const authStore = useAuthenticationStore();
const props = defineProps({
  appointment: Object
});

// console.log(props.appointment.meeting_type);
function supportedTypes() {
  let cnt = 0;
  if (props.appointment?.meeting_types) {
    Object.keys(props.appointment.meeting_types).forEach((type) => {
      if (props.appointment.meeting_types[type] == true) {
        cnt++;
      }
    });
  }
  return cnt;
}
// console.log(supportedTypes());
function save(type) {
  const meeting_detail = {
    pta_id: props.appointment.pta_id,
    meeting_type: type,
    message: props.appointment.comment,
    callback_number: props.appointment.callback_number || authStore.me.phone
  };
  // eslint-disable-next-line vue/no-mutating-props
  props.appointment.meeting_type = type;
  agendaStore.saveDetails(meeting_detail);
}

const id = Math.random() * 999999;
</script>

<style scoped>
/* Fix for Bootstrap btn-check not showing selected state */
.btn-check:checked + .btn-outline-primary {
  background-color: #800c1b !important;
  border-color: #800c1b !important;
  color: #ffffff !important;
}

.btn-check:focus + .btn-outline-primary {
  box-shadow: 0 0 0 0.25rem rgba(128, 12, 27, 0.25);
}

/* Alternative fallback if the above doesn't work */
.btn-group-radio .btn-check:checked + .btn {
  background-color: #800c1b !important;
  border-color: #800c1b !important;
  color: #ffffff !important;
}
</style>
